<template>
    <div class="relative items-start p-4 mx-auto shadow-lg md:p-10 rounded-xl lg:w-9/12 md-max:max-w-lg"
        style="background: linear-gradient(to right, #ffe6e6, #fff5f5);">

        <h2 class="max-w-2xl px-4 mx-auto mb-3 text-center md:mb-5 h2">
            Does Your Kombucha Have LIVE Bacteria (Probiotics)? Ours Does!
        </h2>

        <p class="mb-2 text-center md:mb-5 textp" ref="videoElement">
            Ever wonder if your kombucha really packs a probiotic punch? Ours does! We're all about keeping it real with our kombucha, ensuring every bubbly sip is bursting with live, gut-friendly bacteria. No mysteries here, just good, honest health in every bottle. Let's toast to a happier gut together!
        </p>

        <div class="relative max-w-screen-lg m-auto">

            <div :class="showVideo ? 'opacity-0' : 'opacity-100'">
                <nuxt-img src="/assets/images/Bacteria-1.jpg" alt="image poster"
                    class="mx-auto sm:w-8/12 lg:w-7/12"
                    width="1040" height="585" format="webp" sizes="sm:400px md:100vw lg:100vw xl:1024px" loading="lazy"
                    :class="showVideo ? 'absolute top-0 left-0 right-0 bottom-0 m-auto' : 'rounded-3xl'"></nuxt-img>
                <button ref="playButton" @click="playVid" v-if="!showVideo" aria-label="Start video"
                    class="absolute inset-0 flex flex-col justify-center w-full h-full text-base text-white bg-opacity-75">
                    <svg class="w-20 mx-auto md:w-28" viewBox="-13 -7 205 151" fill="none"
                        xmlns="http://www.w3.org/2000/svg">
                        <g filter="url(#filter0_d_13_831)">
                            <rect x="31" y="8" width="120" height="120" rx="60" fill="#FAF7F5" />
                            <path
                                d="M106.466 65.4079C108.376 66.6081 108.376 69.3919 106.466 70.5921L84.0571 84.6715C82.0185 85.9524 79.3673 84.4871 79.3673 82.0795L79.3673 53.9205C79.3673 51.5129 82.0185 50.0476 84.0571 51.3284L106.466 65.4079Z"
                                fill="#BB555D" />
                        </g>
                        <defs>
                            <filter id="filter0_d_13_831" x="0.387754" y="0.653061" width="181.224" height="181.224"
                                filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
                                <feFlood flood-opacity="0" result="BackgroundImageFix" />
                                <feColorMatrix in="SourceAlpha" type="matrix"
                                    values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha" />
                                <feOffset dy="23.2653" />
                                <feGaussianBlur stdDeviation="15.3061" />
                                <feComposite in2="hardAlpha" operator="out" />
                                <feColorMatrix type="matrix"
                                    values="0 0 0 0 0.211765 0 0 0 0 0.2 0 0 0 0 0.14902 0 0 0 0.3 0" />
                                <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_13_831" />
                                <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_13_831"
                                    result="shape" />
                            </filter>
                        </defs>
                    </svg>
                </button>
            </div>

            <div :class="showVideo ? 'opacity-100' : 'opacity-0'" id="video-container" v-if="showVideo" class="relative mx-auto overflow-hidden sm:w-8/12 lg:w-7/12 lg:px-4">
                <video id="myVideo"
                    src="https://cdn.shopify.com/videos/c/o/v/3fc93e0b58a347aeb36ab13d37b09a49.mp4"
                    class="top-0 left-0 w-full h-full rounded-3xl lg:min-h-[600px] min-h-96" allow="autoplay; fullscreen" loop="false"
                     autoplay muted playsinline controls=""></video>
            </div>
        </div>
    </div>
</template>

<script setup>


const showVideo = ref(false);
const videoPlay = ref(false);
const videoElement = ref(null);
const videoPlayer = ref(null);
const playButton = ref(null);

const playVid = () => {
    videoPlay.value = true;
    showVideo.value = true;

    nextTick(() => {
        videoElement.value.scrollIntoView({ behavior: 'smooth' });
        if (videoPlayer.value) {
            videoPlayer.value.play();
        }
    });
};
</script>

<style scoped>
.transition-opacity {
    transition: opacity 0.1s ease-in-out;
}
</style>